import state from './moduleExpenseState.js'
import mutations from './moduleExpenseMutations.js'
import actions from './moduleExpenseActions.js'
import getters from './moduleExpenseGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
